import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import DashboardLayout from "./components/layouts/DashboardLayout";
import ProtectedRoute from "./utils/ProtectedRoute";
import CustomerProtectedRoute from "./utils/CustomerProtectedRoute";
import Home from "./pages/Home";
import TutorRegister from "./pages/TutorRegister";
import TutorLogin from "./pages/TutorLogin";
import TutorDashboard from "./pages/TutorDashboard";
import ProfileCompletion from "./pages/ProfileCompletion";
import DocumentUpload from "./pages/DocumentUpload";
import SkillTest from "./pages/SkillTest";
import Success from "./pages/Success";
import Settings from "./pages/Settings";
import ProfileReviewStatus from "./pages/ProfileReviewStatus";
import DemoBookings from "./pages/DemoBookings";
import TutorIdCard from "./pages/TutorIdCard";
import PublicTutorProfile from "./pages/PublicTutorProfile";
import TutorProfile from "./pages/TutorProfile";
import CustomerLogin from "./pages/CustomerLogin";
import CustomerRegister from "./pages/CustomerRegister";
import CustomerDashboard from "./pages/CustomerDashboard";
import CustomerDashboardLayout from "./components/layouts/CustomerDashboardLayout";
import BookDemo from "./pages/customer/BookDemo";
import TeacherQueryForm from "./pages/customer/TeacherQueryForm";
import SearchResults from "./pages/SearchResults";
import StudentList from "./pages/customer/StudentList";
import AddStudent from "./pages/customer/AddStudent";
import EditStudent from "./pages/customer/EditStudent";
import MyBookings from "./pages/customer/MyBookings";
import BookingDetail from "./pages/customer/BookingDetail";
import { CustomerAuthProvider } from "./context/CustomerAuthContext";
import { Toaster } from "./components/ui/sonner";
import { Toaster as ToastProvider } from "./components/ui/toaster";
import ErrorBoundary from "./components/ErrorBoundary";
import HelpCenter from "./pages/HelpCenter";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import FAQs from "./pages/FAQs";
import ContactUs from "./pages/ContactUs";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
      <BrowserRouter>
        <CustomerAuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/tutor/:tutorCode" element={<PublicTutorProfile />} />
            <Route path="/tutor-profile/:tutorCode" element={
              <>
                <Navbar />
                <TutorProfile />
                <Footer />
              </>
            } />
            <Route path="/" element={
              <>
                <Navbar />
                <Home />
                <Footer />
              </>
            } />
            <Route path="/tutor/register" element={
              <>
                <Navbar />
                <TutorRegister />
                <Footer />
              </>
            } />
            <Route path="/tutor/login" element={
              <>
                <Navbar />
                <TutorLogin />
                <Footer />
              </>
            } />
            
            {/* Customer Auth Routes */}
            <Route path="/customer/login" element={
              <>
                <Navbar />
                <CustomerLogin />
                <Footer />
              </>
            } />
            <Route path="/customer/register" element={<CustomerRegister />} />
            
            {/* Customer Protected Routes */}
            <Route path="/customer/dashboard" element={
              <CustomerProtectedRoute>
                <CustomerDashboardLayout>
                  <CustomerDashboard />
                </CustomerDashboardLayout>
              </CustomerProtectedRoute>
            } />
            <Route path="/customer/students" element={
              <CustomerProtectedRoute>
                <Navbar />
                <StudentList />
                <Footer />
              </CustomerProtectedRoute>
            } />
            <Route path="/customer/students/add" element={
              <CustomerProtectedRoute>
                <Navbar />
                <AddStudent />
                <Footer />
              </CustomerProtectedRoute>
            } />
            <Route path="/customer/students/edit/:id" element={
              <CustomerProtectedRoute>
                <Navbar />
                <EditStudent />
                <Footer />
              </CustomerProtectedRoute>
            } />
            <Route path="/customer/bookings" element={
              <CustomerProtectedRoute>
                <Navbar />
                <MyBookings />
                <Footer />
              </CustomerProtectedRoute>
            } />
            <Route path="/customer/bookings/:id" element={
              <CustomerProtectedRoute>
                <Navbar />
                <BookingDetail />
                <Footer />
              </CustomerProtectedRoute>
            } />
            {/* NOTE: "Book Demo" feature is temporarily on hold. Route kept for future use.
            <Route path="/customer/book-demo/:tutorId" element={
              <CustomerProtectedRoute>
                <Navbar />
                <BookDemo />
                <Footer />
              </CustomerProtectedRoute>
            } />
            */}
            <Route path="/customer/teacher-query" element={
              <CustomerProtectedRoute>
                <Navbar />
                <TeacherQueryForm />
                <Footer />
              </CustomerProtectedRoute>
            } />
            
            <Route path="/search-results" element={
              <>
                <Navbar />
                <SearchResults />
                <Footer />
              </>
            } />
            
            {/* Static Information Pages */}
            <Route path="/help-center" element={
              <>
                <Navbar />
                <HelpCenter />
                <Footer />
              </>
            } />
            <Route path="/privacy-policy" element={
              <>
                <Navbar />
                <PrivacyPolicy />
                <Footer />
              </>
            } />
            <Route path="/terms-of-service" element={
              <>
                <Navbar />
                <TermsOfService />
                <Footer />
              </>
            } />
            <Route path="/faqs" element={
              <>
                <Navbar />
                <FAQs />
                <Footer />
              </>
            } />
            <Route path="/contact-us" element={
              <>
                <Navbar />
                <ContactUs />
                <Footer />
              </>
            } />
          
          {/* Dashboard Routes with DashboardLayout and ProtectedRoute */}
          <Route path="/tutor/dashboard" element={
            <ProtectedRoute>
              <DashboardLayout>
                <TutorDashboard />
              </DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/tutor/profile-completion" element={
            <ProtectedRoute>
              <DashboardLayout>
                <ProfileCompletion />
              </DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/tutor/document-upload" element={
            <ProtectedRoute>
              <DashboardLayout>
                <DocumentUpload />
              </DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/tutor/skill-test" element={
            <ProtectedRoute>
              <DashboardLayout>
                <SkillTest />
              </DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/tutor/settings" element={
            <ProtectedRoute>
              <DashboardLayout>
                <Settings />
              </DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/tutor/review-status" element={
            <ProtectedRoute>
              <DashboardLayout>
                <ProfileReviewStatus />
              </DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/tutor/demo-bookings" element={
            <ProtectedRoute>
              <DashboardLayout>
                <DemoBookings />
              </DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/tutor/id-card" element={
            <ProtectedRoute>
              <DashboardLayout>
                <TutorIdCard />
              </DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/tutor/success" element={<Success />} />
        </Routes>
        <Toaster />
        <ToastProvider />
        </CustomerAuthProvider>
      </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
